import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  /* -------------- 用户管理 ----------- */
  {
    path: '/user-admin',
    name: 'UserAdmin',
    component: Main,
    meta: {
      disabled: true,
      hideInBread: true,
      label: '用户管理'
    },
    children: [
      {
        name: 'UserListSuperAdmin',
        path: 'user/superAdmin',
        props: true,
        components: {
          default: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Binding/userManagementAdmin'),
          children: ParentView,
        },
        meta: {
          label: '用户管理(super admin)',
          icon: 'mdi-account'
        },
      },
      {
        name: 'UserRegister',
        path: 'user/register',
        redirect: {name: 'PartnerList'},
        props: true,
        component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/registerParent'),
        meta: {
          disabled: true,
          label: '用户预登记',
          icon: 'mdi-account',
          tabId: () => 'UserRegister'
        },
        children: [
          {
            path: 'partner',
            name: 'PartnerList',
            props: true,
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Partner/partnerList'),
            meta: {
              label: '合作用户预登记'
            }
          },
          {
            path: 'partner',
            name: 'PartnerParent',
            props: true,
            redirect: {name: 'PartnerList'},
            component: ParentView,
            meta: {
              label: '合作用户预登记'
            },
            children: [
              {
                path: ':name/readonly',
                name: 'PartnerDetails',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Partner/details'),
                meta: {
                  label: '合作用户详情',
                  cacheKey: 'query.code',
                  subText: 'params.name'
                }
              },
              {
                path: ':name/edit',
                name: 'EditPartner',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Partner/edit'),
                meta: {
                  label: '编辑合作用户',
                  cacheKey: 'query.code',
                  subText: 'params.name'
                }
              },
              {
                path: 'new',
                name: 'NewPartner',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Partner/new'),
                meta: {
                  label: '新增合作用户',
                }
              },
              {
                path: 'new',
                name: 'NewPartnerExport',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Partner/newExport'),
                meta: {
                  label: '导入合作用户',
                }
              },
            ]
          },
          {
            path: 'teacher',
            name: 'TeacherList',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Teacher/teacherList'),
            meta: {
              label: '教职工预登记'
            },
          },
          {
            path: 'teacher',
            name: 'TeacherParent',
            redirect: {name: 'TeacherList'},
            component: ParentView,
            meta: {
              label: '教职工预登记'
            },
            children: [
              {
                path: ':name/readonly',
                name: 'TeacherDetails',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Teacher/details'),
                meta: {
                  label: '教职工详情',
                  cacheKey: 'query.code',
                  subText: 'params.name'
                }
              },
            ]
          },
          {
            path: 'jjs',
            name: 'JjsList',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Jjs/jjsList'),
            meta: {
              label: '继教生预登记'
            }
          },
          {
            path: 'jjs',
            name: 'JjsParent',
            redirect: {name: 'JjsList'},
            component: ParentView,
            meta: {
              label: '继教生预登记'
            },
            children: [
              {
                path: ':name/readonly',
                name: 'JjsDetails',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Jjs/details'),
                meta: {
                  label: '继教生详情',
                  cacheKey: 'query.code',
                  subText: 'params.name'
                }
              },
            ]
          },
          {
            path: 'zjs',
            name: 'ZjsList',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Zjs/zjsList'),
            meta: {
              label: '终教生预登记'
            }
          },
          {
            path: 'zjs',
            name: 'ZjsParent',
            redirect: {name: 'ZjsList'},
            component: ParentView,
            meta: {
              label: '终教生预登记'
            },
            children: [
              {
                path: ':name/readonly',
                name: 'ZjsDetails',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Zjs/details'),
                meta: {
                  label: '终教生详情',
                  cacheKey: 'query.code',
                  subText: 'params.name'
                }
              },
            ]
          },
          {
            path: 'bachelor',
            name: 'BachelorList',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Bachelor/bachelorList'),
            meta: {
              label: '本科生预登记'
            }
          },
          {
            path: 'bachelor',
            name: 'BachelorParent',
            redirect: {name: 'BachelorList'},
            component: ParentView,
            meta: {
              label: '本科生预登记'
            },
            children: [
              {
                path: ':name/readonly',
                name: 'BachelorDetails',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Bachelor/details'),
                meta: {
                  label: '本科生详情',
                  cacheKey: 'query.code',
                  subText: 'params.name'
                }
              },
            ]
          },
          {
            path: 'master',
            name: 'MasterList',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Master/masterList'),
            meta: {
              label: '硕士生预登记'
            }
          },
          {
            path: 'master',
            name: 'MasterParent',
            redirect: {name: 'MasterList'},
            component: ParentView,
            meta: {
              label: '硕士生预登记'
            },
            children: [
              {
                path: ':name/readonly',
                name: 'MasterDetails',
                component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Register/Master/details'),
                meta: {
                  label: '硕士生详情',
                  cacheKey: 'query.code',
                  subText: 'params.name'
                }
              },
            ]
          },
        ]
      },
      {
        name: 'UserBinding',
        path: 'user/binding',
        props: true,
        component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Binding/userManagement'),
        meta: {
          // hideInBread: true,
          label: '用户绑定',
          icon: 'mdi-account'
        },
      },
      {
        name: 'UserBindingParent',
        path: 'user/binding',
        component: ParentView,
        meta: {
          // hideInBread: true,
          label: '用户绑定',
          icon: 'mdi-account'
        },
        children: [
          {
            name: 'UserDetails',
            path: ':loginId/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Binding/userDetails'),
            props: true,
            meta: {
              label: '用户详情',
              subText: 'params.loginId',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'userExtraConfigBox',
            path: 'userExtraConfigBox',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Binding/userExtraConfigBox'),
            props: true,
            meta: {
              label: '用户额外配置',
            },
          },
          {
            name: 'NewUser',
            path: 'new',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Binding/newUser'),
            // component: newUser,
            props: true,
            meta: {
              label: '新增用户',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditUser',
            path: ':loginId/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/User/Binding/editUser'),
            // component: newUser,
            props: true,
            meta: {
              label: '编辑用户',
              subText: 'params.loginId',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'GroupList',
        path: 'group',
        props: true,
        component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/groupList'),
        meta: {
          label: '分组信息',
        },
      },
      {
        name: 'GroupParent',
        props: true,
        redirect: {name: 'GroupList'},
        path: 'group',
        component: ParentView,
        meta: {
          label: '分组信息',
        },
        children: [
          {
            name: 'GroupDetails',
            path: ':name/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/details'),
            props: true,
            meta: {
              label: '用户分组详情',
              subText: 'params.name',
            },
          },
          {
            name: 'passGroupDetails',
            path: 'passGroupDetails',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/passGroupDetails'),
            props: true,
            meta: {
              label: '车辆分组详情',
            },
          },
          {
            name: 'personPassGroupDetails',
            path: 'personPassGroupDetails',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/personPassGroupDetails'),
            props: true,
            meta: {
              label: '行人分组详情',
            },
          },
          {
            name: 'NewGroup',
            path: 'new',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/new'),
            meta: {
              label: '新增分组',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditGroup',
            path: ':name/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/edit'),
            meta: {
              label: '编辑分组',
              subText: 'params.name',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'OrganizationList',
        path: 'organization',
        props: true,
        component: () => import('@/views/UserAdmin/Organization/organizationList'),
        meta: {
          label: '单位管理',
        },
      },
      {
        name: 'OrgParent',
        props: true,
        redirect: {name: 'OrganizationList'},
        path: 'organization',
        component: ParentView,
        meta: {
          label: '单位管理',
        },
        children: [
          {
            name: 'OrgDetails',
            path: ':name/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Organization/details'),
            props: true,
            meta: {
              label: '单位详情',
              subText: 'params.name',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'NewOrg',
            path: 'new',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Organization/new'),
            meta: {
              label: '新增单位',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditOrg',
            path: ':name/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Organization/edit'),
            meta: {
              label: '编辑单位',
              subText: 'params.name',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'ReservationGroupList',
        path: 'ReservationGroupList',
        props: true,
        component: () => import('@/views/UserAdmin/Organization/reservationGroupList'),
        meta: {
          label: '预约分组管理',
        },
      },
      {
        name: 'ReservationGroupListParent',
        props: true,
        redirect: {name: 'ReservationGroupList'},
        path: 'ReservationGroupList',
        component: ParentView,
        meta: {
          label: '预约分组管理',
        },
        children: [
          {
            name: 'reservationGroupDetail',
            path: ':name/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Organization/reservationGroupDetail'),
            props: true,
            meta: {
              label: '预约分组详情',
              subText: 'params.name',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'EditOrg',
            path: ':name/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Organization/edit'),
            meta: {
              label: '编辑分组',
              subText: 'params.name',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'cooperateOrganization',
        path: 'cooperateOrganization',
        props: true,
        component: () => import('@/views/UserAdmin/Organization/cooperateOrganizationList'),
        meta: {
          label: '合作单位管理',
        },
      },
      {
        name: 'cooperateOrganizationListParent',
        props: true,
        redirect: {name: 'cooperateOrganization'},
        path: 'cooperateOrganizationListParent',
        component: ParentView,
        meta: {
          label: '合作单位管理',
        },
        children: [
          {
            name: 'cooperateOrganizationDetailBox',
            path: ':name/readonly',
            component: () => import( '@/views/UserAdmin/Organization/cooperateOrganizationDetailBox'),
            props: true,
            meta: {
              label: '合作单位详情',
              subText: 'params.name',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'EditOrg',
            path: ':name/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Organization/edit'),
            meta: {
              label: '编辑合作单位',
              subText: 'params.name',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'InstitutionList',
        path: 'institution',
        props: true,
        component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Institution/institutionList'),
        meta: {
          label: '机构管理',
        },
      },
      {
        name: 'InstitutionParent',
        redirect: {name: 'InstitutionList'},
        path: 'institution',
        component: ParentView,
        props: true,
        meta: {
          label: '机构管理',
        },
        children: [
          {
            name: 'InstitutionDetails',
            path: ':name/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Institution/details'),
            props: true,
            meta: {
              label: '机构详情',
              subText: 'params.name',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'NewInstitution',
            path: 'new',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Institution/new'),
            meta: {
              label: '新增机构',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditInstitution',
            path: ':name/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Institution/edit'),
            meta: {
              label: '编辑机构',
              subText: 'params.name',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'PermissionList',
        path: 'permission',
        props: true,
        component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Permission/permissionList'),
        meta: {
          label: '权限管理',
        },
      },
      {
        name: 'PermissionParent',
        redirect: {name: 'PermissionList'},
        path: 'permission',
        component: ParentView,
        meta: {
          label: '权限管理',
        },
        children: [
          {
            name: 'PermissionDetails',
            path: ':shiroStr/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Permission/details'),
            props: true,
            meta: {
              label: '权限详情',
              subText: 'params.shiroStr',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'NewPermission',
            path: 'new',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Permission/new'),
            meta: {
              label: '新增权限',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditPermission',
            path: ':shiroStr/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Permission/edit'),
            meta: {
              label: '编辑权限',
              subText: 'params.shiroStr',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'RoleList',
        path: 'role',
        component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Role/roleList'),
        meta: {
          label: '角色管理',
        },
      },
      {
        name: 'RoleParent',
        redirect: {name: 'RoleList'},
        path: 'role',
        component: ParentView,
        meta: {
          label: '角色管理',
        },
        children: [
          {
            name: 'RoleDetails',
            path: ':shiroStr/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Role/details'),
            props: true,
            meta: {
              label: '角色详情',
              subText: 'params.shiroStr',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'NewRole',
            path: 'new',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Role/newRole'),
            // component: newUser,
            meta: {
              label: '新增角色',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditRole',
            path: ':shiroStr/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Role/editRole'),
            // component: newUser,
            meta: {
              label: '编辑角色',
              subText: 'params.shiroStr',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'GroupTypeList',
        path: 'group/type',
        props: true,
        component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/Type/typeList'),
        meta: {
          label: '分组类型',
        },
      },
      {
        name: 'GroupTypeParent',
        redirect: {name: 'GroupTypeList'},
        path: 'group/type',
        props: true,
        component: ParentView,
        meta: {
          label: '分组类型',
        },
        children: [
          {
            name: 'GroupTypeDetails',
            path: ':name/readonly',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/Type/details'),
            props: true,
            meta: {
              label: '分组类型详情',
              subText: 'params.name',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'NewGroupType',
            path: 'new',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/Type/new'),
            meta: {
              label: '新增分组类型',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditGroupType',
            path: ':name/edit',
            component: () => import(/* webpackChunkName: "useradmin" */ '@/views/UserAdmin/Group/Type/edit'),
            meta: {
              label: '编辑分组类型',
              subText: 'params.name',
              cacheKey: 'query.id',
            },
          }
        ]
      },
    ]
  },
]
